// useDashboardV3Enabled — F9.2 WAVE 2C kill-switch reader.
// Mirrors useHeaderV3Enabled. Cached per mount.
import { useEffect, useState } from "react";
import { apiFetch } from "@/lib/api";

export default function useDashboardV3Enabled() {
    const [state, setState] = useState({ loading: true, enabled: false, error: null });

    useEffect(() => {
        let mounted = true;
        (async () => {
            try {
                const data = await apiFetch("/kill-switches/dashboard-v3-enabled");
                if (mounted) setState({ loading: false, enabled: !!data.enabled, error: null });
            } catch (e) {
                if (mounted) setState({ loading: false, enabled: false, error: e });
            }
        })();
        return () => { mounted = false; };
    }, []);

    return state;
}
